import { LegalPageLayout } from '../components/LegalPageLayout';
import { SEOHead } from '../components/SEOHead';

const Privacidad = () => {
  return (
    <LegalPageLayout title="Política de Privacidad" lastUpdated="Febrero 2026">
      <SEOHead 
        title="Política de Privacidad"
        description="Política de privacidad de EventCinema.es - Información sobre el tratamiento de datos personales, derechos RGPD y protección de tu información."
        keywords="política privacidad eventcinema, rgpd, protección datos, derechos usuarios"
        canonicalUrl="/privacidad"
        noIndex={false}
      />
      
      <p>
        En Versión Digital S.L. nos tomamos muy en serio la protección de tus datos. Queremos que tu 
        única preocupación sea disfrutar de la función. A continuación, detallamos cómo tratamos tu 
        información personal de forma transparente y segura.
      </p>

      <h2>1. ¿Quién es el Responsable del Tratamiento de tus datos?</h2>
      <ul>
        <li><strong>Titular:</strong> Versión Digital S.L.</li>
        <li><strong>NIF:</strong> B98660459</li>
        <li><strong>Domicilio:</strong> Calle Martínez Ferrando 6, CD. 46004, Valencia</li>
        <li><strong>Email de contacto (DPO):</strong> administracion@versiondigital.es</li>
      </ul>

      <h2>2. ¿Con qué finalidad tratamos tus datos?</h2>
      <p>En el marketplace de Event Cinema, tratamos la información que nos facilitas para:</p>
      <ul>
        <li>
          <strong>Gestión de la compra:</strong> Tramitar la adquisición de tus entradas y enviarte 
          el comprobante/entrada electrónica.
        </li>
        <li>
          <strong>Comunicación operativa:</strong> Avisarte sobre cambios de horario, cancelaciones 
          o incidencias técnicas en la sala de cine elegida.
        </li>
        <li>
          <strong>Optimización de aforo:</strong> Analizar de forma agregada la ocupación para ofrecerte 
          los mejores precios y promociones exclusivas.
        </li>
        <li>
          <strong>Newsletter Cultural:</strong> Si nos das tu consentimiento, te enviaremos información 
          sobre los próximos estrenos de la Royal Opera House, museos o conciertos.
        </li>
        <li>
          <strong>Perfilado básico:</strong> Entender tus gustos (ej. si prefieres ballet u ópera) para 
          que las recomendaciones que veas en la web sean realmente de tu interés.
        </li>
      </ul>

      <h2>3. ¿Cuál es la legitimación para el tratamiento?</h2>
      <ul>
        <li><strong>Ejecución de un contrato:</strong> Necesaria para procesar tu compra de entradas.</li>
        <li><strong>Interés legítimo:</strong> Para mejorar nuestros servicios y garantizar la seguridad del marketplace.</li>
        <li><strong>Consentimiento:</strong> Para el envío de comunicaciones comerciales y el uso de cookies analíticas.</li>
        <li><strong>Obligación legal:</strong> Para el cumplimiento de normativas fiscales y contables.</li>
      </ul>

      <h2>4. ¿A quién comunicaremos tus datos?</h2>
      <p>Para que la magia ocurra, necesitamos compartir información mínima con:</p>
      <ul>
        <li>
          <strong>Exhibidores (Cines):</strong> Les facilitamos los datos necesarios para validar tu 
          entrada en el acceso a la sala.
        </li>
        <li>
          <strong>Pasarelas de Pago:</strong> Para procesar el cobro de forma segura (nosotros no 
          almacenamos tus datos bancarios completos).
        </li>
        <li>
          <strong>Proveedores de servicios técnicos:</strong> Hosting y plataformas de envío de email 
          bajo estrictos contratos de confidencialidad.
        </li>
      </ul>
      <div className="highlight-box">
        <p>
          <strong>Nota importante:</strong> En ningún caso vendemos tus datos a terceros ajenos a la 
          operativa de tu evento cultural.
        </p>
      </div>

      <h2>5. ¿Cuánto tiempo conservaremos tus datos?</h2>
      <p>
        Conservaremos tus datos personales mientras sean necesarios para la prestación del servicio 
        (el evento), mientras no solicites su supresión y durante los plazos legales obligatorios 
        (normalmente 5 años por temas fiscales).
      </p>

      <h2>6. Tus Derechos</h2>
      <p>Como usuario, tienes el control total. Puedes ejercer tus derechos de:</p>
      <ul>
        <li><strong>Acceso:</strong> Saber qué datos tenemos de ti.</li>
        <li><strong>Rectificación:</strong> Corregir datos inexactos.</li>
        <li><strong>Supresión (Olvido):</strong> Solicitar que borremos tus datos.</li>
        <li><strong>Oposición y Limitación:</strong> Oponerte al tratamiento para fines de marketing.</li>
        <li><strong>Portabilidad:</strong> Recibir tus datos en un formato electrónico.</li>
      </ul>
      <p>
        Para ejercer estos derechos, solo tienes que enviarnos un correo a{' '}
        <a href="mailto:administracion@versiondigital.es">administracion@versiondigital.es</a>{' '}
        adjuntando una copia de tu DNI o documento equivalente para verificar tu identidad.
      </p>

      <h2>7. Seguridad de los datos</h2>
      <p>
        Contamos con medidas de seguridad técnicas (encriptación SSL) y organizativas para evitar la 
        pérdida, mal uso o acceso no autorizado a tus datos. Tu confianza es nuestra prioridad.
      </p>

      <h2>8. Cambios en la Política</h2>
      <p>
        Nos reservamos el derecho a modificar esta política para adaptarla a novedades legislativas 
        o cambios en nuestro modelo de negocio. Siempre verás la fecha de "Última actualización" 
        al final del documento.
      </p>
    </LegalPageLayout>
  );
};

export default Privacidad;
